import React from 'react';
const moment = require('moment');
import ReactTooltip from 'react-tooltip';
import ContentLoader from 'react-content-loader';
import { NoDataImg } from '../../img';


const ShopifyWidgetList = ({
  userWidget,
  editWidget,
  currWidgetMst,

  rdtEditWidget,
  deleteWidget,
  openCloseHireusModel,

  changeWidgetStatus,
  openGetCodeModel,
  handelWidgetNameEdit,

  handleWidgetNameSave,
  handelwidgetNameClose,
  getAnalytic,

  getLatestQuotaUses,
  state
}) => {
  let usedQuota = (state.usedQuota && state.assignQuota) ? Math.floor((state.usedQuota / state.assignQuota) * 100) : 0;
  return (
    <div className="app-dshbrd-list shopify-app-dashboard">
      <div className="row">
        <div className="col-xs-12 header-shopify-col">
          <div className="header-shopify">
            <div className="header-shopify-part header-shopify-left">
              <h2 className="hdrspfy-part-title">{currWidgetMst.dn}</h2>
              {userWidget && userWidget.length > 0 &&
                <span className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-min15x" onClick={() => rdtEditWidget(currWidgetMst)}>Create Wall</span>
              }
            </div>
            <div className="header-shopify-part header-shopify-center">
              <div className="rightbar-progress-part">
                <span className="progress-top-left">Plan usage</span>
                <div className="progress-top-btm">
                  <span className="progress-quta-text progress-quta-use">{state.usedQuota}</span>
                  <div className="progress-bar-wrap">
                    <div className="progress-bar-line" style={{ width: usedQuota + '%' }}></div>
                  </div>
                  <span className="progress-quta-text progress-quta-assign"> {state.assignQuota}</span>
                </div>
                <span className="progress-right">100%</span>
              </div>
              <div className="btn-refresh btn-refresh-palnus" data-tip="true" data-for="sync" currentitem="false" onClick={() => getLatestQuotaUses()}>
                <svg xmlns="http://www.w3.org/2000/svg" className={state.usedQuota == '-' ? 'svg-spin-animation' : ''} width="16.036" height="16.686" viewBox="0 0 16.036 16.686">
                  <path id="Path_627" data-name="Path 627" d="M48.123,22.684a.6.6,0,0,0,.762.382h0L52.5,21.859a.6.6,0,0,0,.412-.572V17.67a.6.6,0,0,0-1.206,0v2.2a7.759,7.759,0,1,0,2.3,4.329.6.6,0,1,0-1.191.19l0,.011a6.638,6.638,0,1,1-1.648-3.371l-2.671.89a.6.6,0,0,0-.382.762Z" transform="translate(-38.354 -16.817)" fill="#4c84ff" stroke="#4c84ff" strokeWidth="0.5">
                  </path>
                </svg>
                <span>Refresh</span>
              </div>
            </div>
            <div className="header-shopify-part header-shopify-right">
              <div className="icon-link icon-link-hireus" data-tip data-for="hireus" onClick={() => openCloseHireusModel()}>
                <svg width="20" height="20" id="Group_8360" data-name="Group 8360" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.667 26.667">
                  <path fill="#8392a5" id="Path_12826" data-name="Path 12826" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.326,13.326,0,0,0,13.333,0Zm0,24.889A11.556,11.556,0,1,1,24.889,13.333,11.569,11.569,0,0,1,13.333,24.889Z" />
                  <path fill="#8392a5" id="Path_12827" data-name="Path 12827" d="M239.819,209.777a.889.889,0,0,0-.889.889v7.5a.889.889,0,0,0,1.778,0v-7.5A.889.889,0,0,0,239.819,209.777Z" transform="translate(-226.485 -198.851)" />
                  <path fill="#8392a5" id="Path_12828" data-name="Path 12828" d="M223.645,124.122a1.778,1.778,0,1,0,1.778,1.778A1.78,1.78,0,0,0,223.645,124.122Z" transform="translate(-210.312 -117.657)" />
                </svg>
                <ReactTooltip id="hireus" aria-haspopup='true' role='example'>
                  <span>Hire Us</span>
                </ReactTooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      {userWidget && userWidget.length > 0 ?
        <div className="row">
          {
            userWidget.map((val, key) => {
              return (
                <div className="col-xs-12" key={key}>
                  <div className="wdgt-detail-sites-list">
                    <div className="wdgt-thread-box">
                      <div className="wdgt-inblock wdgt-thread-name">
                        <div className="wdgt-name-block">
                          <h5 className="noti-type-name" id={`${'widgetName_' + key}`}> {val.wdsc}
                            <svg className="edit edit-notiname-icon" onClick={() => handelWidgetNameEdit(`${'widgetName_' + key}`, `${'widgetInput_' + key}`, `${'widgetEditInput_' + key}`, val.wdsc)} xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="14.244" height="14.184" viewBox="0 0 14.244 14.184">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_164" data-name="Rectangle 164" width="14.244" height="14.184" fill="#8392a5" />
                                </clipPath>
                              </defs>
                              <g id="edit" clipPath="url(#clip-path)">
                                <path id="Path_240" data-name="Path 240" d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0" transform="translate(40.118 -52.977)" fill="#8392a5" />
                              </g>
                            </svg>
                          </h5>
                          <div id={`${'widgetInput_' + key}`} className="edit-noti-name" style={{ display: 'none' }}>
                            <div className="editwdgt-name-box">
                              <input placeholder='Widget Name' id={`${'widgetEditInput_' + key}`} />
                              <span className="editnoti-action editnoti-save" onClick={() => handleWidgetNameSave(`${'widgetName_' + key}`, `${'widgetInput_' + key}`, `${'widgetEditInput_' + key}`, val.wdsc, val._id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11.073" height="8.389" viewBox="0 0 11.073 8.389">
                                  <path id="true-1" d="M284.031,373.954l-6.245,6.245a.14.14,0,0,1-.2,0l-3.546-3.546a.139.139,0,0,1,0-.2l.862-.862a.14.14,0,0,1,.2,0l2.585,2.585,5.284-5.284a.14.14,0,0,1,.2,0l.861.862a.14.14,0,0,1,0,.2Zm0,0" transform="translate(-273.5 -372.352)" fill="#000" stroke="#000" strokeWidth="1" />
                                </svg>
                              </span>
                              <span className="editnoti-action editnoti-close" onClick={() => handelwidgetNameClose(`${'widgetName_' + key}`, `${'widgetInput_' + key}`)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8.848" height="8.849" viewBox="0 0 8.848 8.849">
                                  <path id="false" d="M272.794,362.424l3-3a.184.184,0,0,0,0-.261l-1.109-1.109a.184.184,0,0,0-.261,0l-3,3-3-3a.189.189,0,0,0-.261,0l-1.109,1.109a.184.184,0,0,0,0,.261l3,3-3,3a.184.184,0,0,0,0,.261l1.109,1.109a.184.184,0,0,0,.261,0l3-3,3,3a.183.183,0,0,0,.261,0l1.109-1.108a.185.185,0,0,0,0-.261Zm0,0" transform="translate(-267 -358)" fill="#000" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="wdgt-crete-dateblock">
                          <svg xmlns="http://www.w3.org/2000/svg" height="13px" viewBox="0 0 512 512" width="13px">
                            <path d="m453.332031 512h-394.664062c-32.363281 0-58.667969-26.304688-58.667969-58.667969v-352c0-32.363281 26.304688-58.664062 58.667969-58.664062h394.664062c32.363281 0 58.667969 26.300781 58.667969 58.664062v352c0 32.363281-26.304688 58.667969-58.667969 58.667969zm-394.664062-437.332031c-14.699219 0-26.667969 11.964843-26.667969 26.664062v352c0 14.699219 11.96875 26.667969 26.667969 26.667969h394.664062c14.699219 0 26.667969-11.96875 26.667969-26.667969v-352c0-14.699219-11.96875-26.664062-26.667969-26.664062zm0 0"></path><path d="m496 202.667969h-480c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h480c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="m122.667969 128c-8.832031 0-16-7.167969-16-16v-96c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0"></path><path d="m389.332031 128c-8.832031 0-16-7.167969-16-16v-96c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0"></path>
                          </svg>
                          <span data-tip data-for={`${'dt_' + key}`} className="wdgt-crete-date">{val.udt ? moment(new Date(val.udt)).format('MMM-DD-YYYY') : ''}</span>
                          <ReactTooltip id={`${'dt_' + key}`} aria-haspopup='true' role='example'>
                            <p className="noti-date-text">Created date : {moment(new Date(val.insdt)).format('MMM-DD-YYYY hh:mm:ss a')} </p>
                            <p className="noti-date-text">Updated date : {moment(new Date(val.udt)).format('MMM-DD-YYYY hh:mm:ss a')} </p>
                          </ReactTooltip>
                        </div>
                      </div>
                      <div className="wdgt-inblock wdgt-thread-design">
                        <div className="wdgt-btn-getcode">
                          <a className="tbl-seehty-btn" onClick={() => openGetCodeModel(val)}>Get code </a>
                        </div>
                        {
                          (val.today == undefined && val.week == undefined && val.month == undefined) &&
                          <div className="wdgt-btn-analtcs" onClick={() => getAnalytic(val.unqid, val._id)}>
                            <a className="tbl-seehty-btn">See Visitor Count </a>
                          </div>
                        }
                      </div>
                      <div className="wdgt-inblock wdgt-thread-rightgroup">
                        <div className="wdgt-inblock-part wdgt-thread-action">
                          <label className="switch">
                            <input type="checkbox" checked={val.ia ? true : false} onChange={(e) => changeWidgetStatus(val, 'ia', e.target.checked)} />
                            <span className="slider round"></span>
                          </label>
                          <div className="wdgt-icon-box25 wdgt-icon-edit wdgt-editeditor" data-tip data-for={`${'edit_' + key}`} onClick={() => editWidget(val)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14.233" height="14.164" viewBox="0 0 14.233 14.164">
                              <path id="Path_240" data-name="Path 240" d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0" transform="translate(40.12 -52.998)" fill="#b0bec5" />
                            </svg>
                            <ReactTooltip id={`${'edit_' + key}`} aria-haspopup='true' role='example'>
                              <p>Edit</p>
                            </ReactTooltip>
                          </div>
                          <div className="wdgt-icon-box25 wdgt-icon-delete wdgt-item-delete" onClick={() => deleteWidget(val)} data-tip data-for={`${'delete_' + key}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 8.8 9.6">
                              <g id="_06-trash" data-name="06-trash" transform="translate(-8)">
                                <path id="Path_12750" data-name="Path 12750" d="M16.8,1.6H14V1.2A1.2,1.2,0,0,0,12.8,0H12a1.2,1.2,0,0,0-1.2,1.2v.4H8v.8h.442l.681,6.133A1.2,1.2,0,0,0,10.316,9.6h4.168a1.2,1.2,0,0,0,1.193-1.068L16.358,2.4H16.8Zm-5.2-.4A.4.4,0,0,1,12,.8h.8a.4.4,0,0,1,.4.4v.4H11.6Zm3.282,7.244a.4.4,0,0,1-.4.356H10.316a.4.4,0,0,1-.4-.356L9.247,2.4h6.306Z" fill="#fb5360" />
                                <path id="Path_12751" data-name="Path 12751" d="M88,64h.8v4.8H88Z" transform="translate(-76 -60.8)" fill="#fb5360" />
                                <path id="Path_12752" data-name="Path 12752" d="M0,0H4.817V.8H0Z" transform="translate(13.603 7.965) rotate(-85.241)" fill="#fb5360" />
                                <path id="Path_12753" data-name="Path 12753" d="M0,0H.8V4.817H0Z" transform="translate(10.002 3.235) rotate(-4.759)" fill="#fb5360" />
                              </g>
                            </svg>
                            <ReactTooltip id={`${'delete_' + key}`} aria-haspopup='true' role='example'>
                              <p>Delete</p>
                            </ReactTooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    {(val.today != undefined && val.week != undefined && val.month != undefined) &&
                      <div className="wdgt-analttics-block">
                        {
                          (val.today != '-' && val.week != '-' && val.month != '-') ?
                            <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
                              <thead>
                                <tr>
                                  <th>Last 24 hours</th>
                                  <th>Last 7 days</th>
                                  <th>Last 30 days</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{val.today}</td>
                                  <td>{val.week}</td>
                                  <td>{val.month}</td>
                                  <td>
                                    <div className="btn-refresh btn-refresh-profile" data-tip="true" data-for="sync" currentitem="false" onClick={() => getAnalytic(val.unqid, val._id)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16.036" height="16.686" viewBox="0 0 16.036 16.686">
                                        <path id="Path_627" data-name="Path 627" d="M48.123,22.684a.6.6,0,0,0,.762.382h0L52.5,21.859a.6.6,0,0,0,.412-.572V17.67a.6.6,0,0,0-1.206,0v2.2a7.759,7.759,0,1,0,2.3,4.329.6.6,0,1,0-1.191.19l0,.011a6.638,6.638,0,1,1-1.648-3.371l-2.671.89a.6.6,0,0,0-.382.762Z" transform="translate(-38.354 -16.817)" fill="#4c84ff" stroke="#4c84ff" strokeWidth="0.5">
                                        </path>
                                      </svg>
                                      <span>Refresh</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            :
                            <ContentLoader
                              height={70}
                              width={1067}
                              speed={2}
                              primaryColor="#eceef4"
                              secondaryColor="#fff">
                              <rect x="10" y="5" rx="5" ry="5" width="1055" height="25" />
                              <rect x="10" y="35" rx="5" ry="5" width="1055" height="20" />
                            </ContentLoader>
                        }
                      </div>
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
        :
        <div className="nodata-center-block">
          <div className="clearfix"></div>
          <div className="nodata-block">
            <div className="nodata-box">
              <img src={NoDataImg} alt="No data" />
              <h4>Create your first social or review wall</h4>
              <span className="nf-btn nf-btn-default nf-btn-noneBdr nf-btn-min15x pull-right nf-btn-add-wdgt" onClick={() => rdtEditWidget(currWidgetMst)}>Add Wall</span>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default ShopifyWidgetList;


// WEBPACK FOOTER //
// ./src/components/Widget/ShopifyWidgetList.js